import { ApiService } from "../api.service";
import { CommonService } from "../common.service";
import { ActivatedRoute, Router } from "@angular/router";
var CasePracticeAuthorizationMainComponent = (function () {
    function CasePracticeAuthorizationMainComponent(commonService, apiService, route, router) {
        this.commonService = commonService;
        this.apiService = apiService;
        this.route = route;
        this.router = router;
        this.assetsRoute = "../../assets";
    }
    CasePracticeAuthorizationMainComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.currentWord = "";
        this.noticeShow = false;
        this.optionWrapShow = false;
        this.msgCharacter = 0;
        this.msgTimeout = null;
        this.currentRole = "";
        this.optionClick = false;
        this.optionOnClick = false;
        this.optionClickTimeout = null;
        this.discussionBgMainMode = 0;
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        if (localStorage.getItem('sh')) {
            this.type = 'huatek';
        }
        else {
            this.route.queryParams.subscribe(function (queryParams) {
                _this.type = queryParams['type'];
            });
        }
    };
    CasePracticeAuthorizationMainComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.commonService.initPage({
            'backgroundColor': 'white'
        });
        this.route.params.subscribe(function (params) {
            _this.practiceId = params['practiceId'];
            _this.exerciseId = params['exerciseId'];
            _this.learningPathId = params['learningPathId'];
            _this.apiService.ajax({
                'type': 'get',
                'url': '/api/exercises/' + _this.exerciseId
            }).subscribe(function (result) {
                _this.clickable = true;
                _this.questions = result.questions;
                _this.import = result.import;
                _this.conversationHistory = [];
                _this.currentCaseId = result.id;
                //全局变量初始化为 null
                window["exercises" + _this.currentCaseId] = null;
                if (result.name == '协作') {
                    _this.mode = 2;
                }
                else {
                    _this.mode = 1;
                }
                _this.exerciseInit();
            });
            _this.apiService.ajax({
                'type': 'get',
                'url': '/api/taskBook/' + _this.exerciseId
            }).subscribe(function (result) {
                _this.taskBook = result;
            });
        });
        document.oncontextmenu = function (e) {
            e.preventDefault();
        };
    };
    CasePracticeAuthorizationMainComponent.prototype.exerciseInit = function () {
        var _this = this;
        this.currentFakeWord = "";
        this.msgCharacter = 0;
        this.itemTemp = this.questions[0];
        var roleTemp;
        if (this.mode == 1) {
            roleTemp = '高朗';
        }
        else {
            roleTemp = '方科科';
        }
        do {
            this.optionsTemp = this.itemTemp.options;
            this.optionIndexTemp = this.getSelectedOptionIndex(this.optionsTemp);
            if (this.optionIndexTemp != -1) {
                this.nextQuestionIdTemp = this.optionsTemp[this.optionIndexTemp].nextQuestionId;
                this.conversationHistory.push({
                    'role': roleTemp,
                    'comment': this.itemTemp.description
                });
                if (this.itemTemp.directorComment != '') {
                    this.conversationHistory.push({
                        'role': '导师点评',
                        'comment': this.itemTemp.directorComment
                    });
                }
                this.conversationHistory.push({
                    'role': '我',
                    'comment': this.optionsTemp[this.optionIndexTemp].description
                });
                this.setItemTemp(this.nextQuestionIdTemp);
            }
            else {
                break;
            }
        } while (true);
        if (this.conversationHistory.length != 0) {
            this.conversationHistory.unshift({
                'role': '我',
                'comment': this.import
            });
            this.step = 2.5;
            this.currentRole = "我";
            this.currentWord = this.oldItemTemp.options[this.oldOptionIndexTemp].description;
            this.currentFakeWord = this.currentWord;
            this.currentExpression = this.oldItemTemp.expression;
            this.currentItem = this.itemTemp;
            this.clickable = false;
            // console.log(this.currentExpression);
            // console.log($(this.getDomIdByExpression(this.currentExpression)));
            $(document).ready(function () {
                //$(_this.getDomIdByExpression(_this.currentExpression)).fadeIn(200);
                $('#talkBox1').fadeIn(200); //这两行有bug，不能正常显示，暂时搁置
                if (_this.mode == 1) {
                    $('#reviewBtn').fadeIn(200);
                }
                else {
                    $('#reviewBtn2').fadeIn(200);
                }
                setTimeout(function () {
                    _this.getLetterByLetter($('#talkBoxContent1'));
                }, 500);
                setTimeout(function () {
                    _this.clickable = true;
                }, 750);
            });
        }
        else {
            this.currentWord = this.import;
            this.currentFakeWord = this.currentWord;
            this.currentItem = this.questions[0];
            if (this.mode == 1) {
                this.currentExpression = '开心';
            }
            else {
                this.currentExpression = '正常';
            }
            // $('#notice').fadeIn(200);
            $(document).ready(function () {
                _this.noticeShow = true;
                if (_this.mode == 1) {
                    $('#happy').fadeIn(200);
                    _this.step = 0;
                }
                else {
                    /*$('#common').fadeIn(200);*/
                    _this.step = 11;
                }
            });
        }
    };
    /*  逻辑F
      step 0: 初始化, 用户再次点击屏幕, => step 1
      step 1: 显示我说的话, 再次点击 => step 2
      step 2: 显示当前节点高朗说的话再次点击，如果有导师提示语 => step 3 如果没有导师提示语并有选项 => step 4 如果没有导师提示语并没有选项 => step 5
      step 3: 显示导师提示语, 再次点击 如果有选项 => step 4 如果没有选项 => step 5
      step 4: 显示选项, 点击选项后 => step 1
      step 5; 决策树终止，显示生成报告按钮
    */
    CasePracticeAuthorizationMainComponent.prototype.screenClick = function () {
        var _this = this;
        if (!this.clickable) {
            return;
        }
        this.msgCharacter = 0;
        if (this.step == 0) {
            this.clickable = false;
            this.noticeShow = false;
            this.currentRole = "我";
            setTimeout(function () {
                _this.currentFakeWord = _this.currentWord;
                _this.showSelfTalk();
                $('#reviewBtn').fadeIn(200);
                setTimeout(function () {
                    _this.getLetterByLetter($('#talkBoxContent1'));
                    setTimeout(function () {
                        _this.step = 2.5;
                        _this.clickable = true;
                    }, 1000);
                }, 250);
            }, 1000);
            this.conversationHistory.push({
                'role': '我',
                'comment': this.currentWord
            });
        }
        else if (this.step == 1) {
            this.clickable = false;
            this.oldExpression = this.currentExpression;
            this.currentExpression = this.currentItem.expression;
            this.closeSelfTalk();
            $('#talkBoxContent1').text("");
            if (this.oldExpression != this.currentExpression) {
                $(this.getDomIdByExpression(this.oldExpression)).fadeOut(200);
            }
            setTimeout(function () {
                _this.currentWord = _this.currentItem.description;
                var roleTemp;
                if (_this.mode == 1) {
                    roleTemp = '高朗';
                }
                else {
                    roleTemp = '方科科';
                }
                _this.currentRole = roleTemp;
                _this.conversationHistory.push({
                    'role': roleTemp,
                    'comment': _this.currentWord
                });
                _this.currentFakeWord = _this.currentWord;
                $('#talkBox2').fadeIn(200);
                if (_this.oldExpression != _this.currentExpression) {
                    $(_this.getDomIdByExpression(_this.currentExpression)).fadeIn(200);
                }
                setTimeout(function () {
                    _this.getLetterByLetter($('#talkBoxContent2'));
                    setTimeout(function () {
                        _this.step = 1.5;
                        _this.clickable = true;
                    }, 1000);
                }, 250);
            }, 500);
        }
        else if (this.step == 1.5) {
            this.clickable = false;
            if (this.currentRole == "高朗" || this.currentRole == "方科科") {
                this.showFullText($('#talkBoxContent2'));
            }
            else if (this.currentRole == "我") {
                this.showFullText($('#talkBoxContent1'));
            }
            setTimeout(function () {
                _this.step = 2;
                _this.clickable = true;
            }, 1000);
        }
        else if (this.step == 2) {
            this.clickable = false;
            $('#talkBox1').fadeOut(200);
            $('#talkBox2').fadeOut(200);
            $('#talkBoxContent1').text("");
            $('#talkBoxContent2').text("");
            this.currentHint = this.currentItem.directorComment;
            if (this.currentHint != '') {
                this.currentRole = "导师";
                this.currentWord = this.currentHint;
                setTimeout(function () {
                    _this.currentFakeWord = _this.currentWord;
                    $('#tutorHints').fadeIn(200);
                    setTimeout(function () {
                        _this.showFullText($('#tutorHintsContent'));
                        setTimeout(function () {
                            _this.step = 3;
                            _this.clickable = true;
                        }, 1000);
                        _this.conversationHistory.push({
                            'role': '导师点评',
                            'comment': _this.currentWord
                        });
                    }, 250);
                }, 500);
            }
            else {
                this.currentOptions = this.currentItem.options.sort(function () {
                    return 0.5 - Math.random();
                });
                if (this.currentOptions.length > 0) {
                    setTimeout(function () {
                        _this.step = 4;
                        _this.clickable = false;
                        _this.optionWrapShow = true;
                        $(_this.getDomIdByExpression(_this.currentExpression)).fadeOut(200);
                    }, 1000);
                }
                else {
                    setTimeout(function () {
                        _this.step = 5;
                        _this.clickable = false;
                        $('#generateReportBtn').fadeIn(200);
                    }, 1000);
                }
            }
        }
        else if (this.step == 2.5) {
            this.clickable = false;
            if (this.currentRole == "高朗" || this.currentRole == "方科科") {
                this.showFullText($('#talkBoxContent2'));
            }
            else if (this.currentRole == "我") {
                this.showFullText($('#talkBoxContent1'));
            }
            setTimeout(function () {
                if (_this.currentRole == "高朗" || _this.currentRole == "方科科") {
                    _this.step = 2;
                }
                else if (_this.currentRole == "我") {
                    _this.step = 1;
                }
                _this.clickable = true;
            }, 1000);
        }
        else if (this.step == 3) {
            this.clickable = false;
            $('#tutorHints').fadeOut(200);
            $('#tutorHintsContent').text("");
            this.currentOptions = this.currentItem.options.sort(function () {
                return 0.5 - Math.random();
            });
            if (this.currentOptions.length > 0) {
                setTimeout(function () {
                    _this.step = 4;
                    _this.clickable = false;
                    _this.optionWrapShow = true;
                    $(_this.getDomIdByExpression(_this.currentExpression)).fadeOut(200);
                }, 1000);
            }
            else {
                setTimeout(function () {
                    _this.step = 5;
                    _this.clickable = true;
                    $('#generateReportBtn').fadeIn(200);
                }, 1000);
            }
        }
        else if (this.step == 11) {
            this.clickable = false;
            this.noticeShow = false;
            setTimeout(function () {
                $('#talkBack').fadeIn(200);
                _this.step = 12;
                _this.clickable = true;
            }, 1000);
        }
        else if (this.step == 12) {
            this.clickable = false;
            $('#talkBack').fadeOut(200);
            setTimeout(function () {
                $('#common').fadeIn(200);
                $('#introductionBox').fadeIn(200);
                _this.step = 13;
                _this.clickable = true;
            }, 1000);
        }
        else if (this.step == 13) {
            this.clickable = false;
            $('#introductionBox').fadeOut(200);
            this.currentRole = "我";
            setTimeout(function () {
                _this.currentFakeWord = _this.currentWord;
                _this.showSelfTalk();
                $('#reviewBtn2').fadeIn(200);
                setTimeout(function () {
                    _this.getLetterByLetter($('#talkBoxContent1'));
                    setTimeout(function () {
                        _this.step = 2.5;
                        _this.clickable = true;
                    }, 1000);
                }, 250);
            }, 500);
            this.conversationHistory.push({
                'role': '我',
                'comment': this.currentWord
            });
        }
    };
    CasePracticeAuthorizationMainComponent.prototype.onOptionMouseDown = function (i, event) {
        if (this.optionClick == true || this.optionOnClick == true) {
            return false;
        }
        var _this = this, pressing = $(event.target).children('.pressing'), // 选项背景进度div
        pressingOption = pressing.children('.pressingOption'), // 选项背景进度div中的文字
        pressingWidth = $(event.target).width(), // 选项宽度
        pressingHeight = $(event.target).height(), // 选项高度
        pressingOuterHeight = $(event.target).outerHeight(), // 选项真实高度, 包括margin, padding
        pressingOffset = $(event.target).offset(); // 选项在屏幕的位置
        // 按选项少于0.45s, 则不响应
        this.optionClick = false;
        this.optionOnClick = true;
        // 设置选项动画参数
        pressingOption.width(pressingWidth);
        pressingOption.height(pressingHeight);
        pressing.width(0);
        pressing.height(pressingOuterHeight),
            pressing.show();
        pressing.offset({
            top: pressingOffset.top,
            left: pressingOffset.left
        });
        // 选项背景动画
        pressing.animate({
            width: $(event.target)[0].clientWidth
        }, this.type ? 300 : 500, 'linear');
        // 按中选项到达0.45s, 响应出现动画,  跳入下一个页面
        this.optionClickTimeout = setTimeout(function () {
            // 长按响应
            _this.optionClick = true;
            // 隐藏背景色
            pressing.animate({
                width: 0
            }, 1);
            pressing.hide();
            // 进入选中按钮动画
            $(event.target).addClass('optionLongPress');
            // 按键之后的动画
            $(event.target).find('.loading').fadeIn(200);
            _this.msgCharacter = 0;
            _this.currentRole = "我";
            _this.currentWord = _this.currentOptions[i].description;
            _this.conversationHistory.push({
                'role': '我',
                'comment': _this.currentWord
            });
            // 隐藏文字
            // 其他按钮的消失时间, 设置比选中按钮timeout时间长500ms, 维持按钮相对位置
            _this.currentOptions[i].description = "";
            $('.optionItem').not($(event.target)).fadeOut(2500);
            // 保持选中按钮动画2s, 跳转动画
            setTimeout(function () {
                // 移出按钮动画
                $(event.target).removeClass('optionLongPress');
                _this.step = 2.5;
                _this.apiService.answerExerciseQuestion("" + _this.currentCaseId + "", _this.currentItem.id, _this.currentOptions[i].id).subscribe(function (practice) { });
                //全局缓存最后提交数据
                var exerciseConfig = {
                    questionId: _this.currentItem.id,
                    optionId: _this.currentOptions[i].id,
                    exercisesId: _this.currentCaseId
                };
                window["exercises" + _this.currentCaseId] = exerciseConfig;
                _this.nextQuestionId = _this.currentOptions[i].nextQuestionId;
                _this.setCurrentItem(_this.nextQuestionId);
                _this.optionWrapShow = false;
                setTimeout(function () {
                    _this.currentFakeWord = _this.currentWord;
                    _this.showSelfTalk();
                    setTimeout(function () {
                        _this.getLetterByLetter($('#talkBoxContent1'));
                        setTimeout(function () {
                            _this.clickable = true;
                            _this.optionClick = false;
                        }, 750);
                    }, 250);
                }, 500);
            }, 2000); // end of second setTimeout
        }, 450); // end of first setTimeout
    }; //end of onOptionMouseDown
    CasePracticeAuthorizationMainComponent.prototype.onOptionMouseUp = function (event) {
        var _this = this;
        this.optionOnClick = true;
        setTimeout(function () {
            _this.optionOnClick = false;
        }, 300);
        // 如果已经触发按钮事件, 忽略放松按钮行为
        if (this.optionClick == true) {
            return true;
        }
        var pressing = $(event.target).children('.pressing');
        // 调整宽度为0
        setTimeout(function () {
            clearTimeout(_this.optionClickTimeout);
            pressing.stop().animate({
                width: 0
            }, 300, 'linear');
        }, this.type ? 300 : 0);
    };
    CasePracticeAuthorizationMainComponent.prototype.discussionBgClick = function ($event) {
        $event.stopPropagation();
        this.discussionBgMainMode = (this.discussionBgMainMode + 1) % 2;
    };
    CasePracticeAuthorizationMainComponent.prototype.reviewConversation = function ($event) {
        $event.stopPropagation();
        $('#shade').fadeIn(50);
        $('#reviewBox').fadeIn();
        $('#closeBtn').fadeIn();
        this.clickable = false;
    };
    CasePracticeAuthorizationMainComponent.prototype.taskBookOut = function ($event) {
        $event.stopPropagation();
        $('#shade').fadeIn(50);
        $('#taskBookBox').fadeIn();
        $('#closeBtn').fadeIn();
        this.clickable = false;
    };
    CasePracticeAuthorizationMainComponent.prototype.closeTip = function ($event) {
        $event.stopPropagation();
        $('#shade').fadeOut();
        $('#reviewBox').fadeOut();
        $('#taskBookBox').fadeOut();
        $('#closeBtn').fadeOut();
        // 恢复点击功能
        this.clickable = true;
    };
    CasePracticeAuthorizationMainComponent.prototype.setCurrentItem = function (questionId) {
        var _this = this;
        this.questions.forEach(function (item, index) {
            if (item.id == questionId) {
                _this.currentItem = item;
                return;
            }
        });
    };
    CasePracticeAuthorizationMainComponent.prototype.setItemTemp = function (questionId) {
        var _this = this;
        this.questions.forEach(function (item, index) {
            if (item.id == questionId) {
                _this.oldItemTemp = _this.itemTemp;
                _this.oldOptionIndexTemp = _this.optionIndexTemp;
                _this.itemTemp = item;
                return;
            }
        });
    };
    CasePracticeAuthorizationMainComponent.prototype.getSelectedOptionIndex = function (options) {
        var temp = -1;
        options.forEach(function (item, index) {
            if (item.selected) {
                temp = index;
            }
        });
        return temp;
    };
    CasePracticeAuthorizationMainComponent.prototype.getDomIdByExpression = function (expression) {
        if (this.mode == 1) {
            if (expression == '叙述') {
                return '#narration';
            }
            else if (expression == '开心') {
                return '#happy';
            }
            else if (expression == '担心') {
                return '#worry';
            }
            else if (expression == '疑问') {
                return '#doubt';
            }
        }
        else {
            if (expression == '正常') {
                return '#common';
            }
            else if (expression == '皱眉') {
                return '#frown';
            }
            else if (expression == '得意') {
                return '#proud';
            }
            else if (expression == '挑眉') {
                return '#eyebrow';
            }
            else if (expression == '滴汗') {
                return '#sweat';
            }
            else if (expression == '生气') {
                return '#angry';
            }
        }
    };
    CasePracticeAuthorizationMainComponent.prototype.linkToReport = function () {
        var _this = this;
        this.apiService.finishExercise("" + this.currentCaseId + "").subscribe(function (practice) {
            if ($('#learningPathMetaIdContainer').val() == 11) {
                _this.apiService.getReportKas(_this.exerciseId, _this.practiceId).subscribe(function (result) {
                    console.log(111111, result);
                    if (result) {
                        _this.apiService.getLevelInfo(result.reports[0]);
                    }
                });
            }
            else if ($('#learningPathMetaIdContainer').val() == 14) {
                _this.apiService.getKasInfos(_this.exerciseId, _this.practiceId).subscribe(function (result) {
                    console.log(111111, result);
                    if (result) {
                        _this.apiService.getLevelInfo(result.reports[0]);
                    }
                });
            }
            // this.commonService.learningPortEventLogByCandy({'learningPathMetaId':localStorage.getItem('learningPathMetaId'),'module':'退出情景模拟1'}).then();
            var link = ['case-practice-report-new', _this.practiceId, _this.exerciseId, _this.learningPathId];
            if (_this.type) {
                _this.router.navigate(link, { queryParams: { type: 'huatek' } });
            }
            else {
                _this.router.navigate(link);
            }
        });
        var exerciseMetaId = $('#exerciseMetaId').val();
        this.apiService.learingTime({ learningPathMetaId: $('#learningPathMetaIdContainer').val(), module: '情景模拟', courseUnit: '', type: 2, btnName: exerciseMetaId, userId: localStorage.getItem("userId") }).subscribe(function (result) {
            console.log(result);
        });
        console.log(exerciseMetaId);
        this.commonService.sendPostMessage(2, 'isPractice' + 'Complete');
    };
    CasePracticeAuthorizationMainComponent.prototype.getLetterByLetter = function (container) {
        var _this = this;
        //对话显示全
        //_this.msgCharacter = _this.currentWord.length -1;
        this.msgTimeout = setTimeout(function () {
            _this.msgCharacter++;
            var type = _this.currentWord.substring(0, _this.msgCharacter);
            container.html(type);
            _this.getLetterByLetter(container);
            if (_this.msgCharacter == _this.currentWord.length) {
                if (_this.currentRole == "高朗" || _this.currentRole == "方科科") {
                    _this.step = 2;
                }
                else if (_this.currentRole == "我") {
                    if (_this.step == 2.5) {
                        _this.step = 1;
                    }
                    else if (_this.step == 1.5) {
                        _this.step = 2;
                    }
                }
                clearTimeout(_this.msgTimeout);
            }
        }, 30); // end of setTimeout
    }; // end of getLetterByLetter
    CasePracticeAuthorizationMainComponent.prototype.showFullText = function (container) {
        clearTimeout(this.msgTimeout);
        container.html(this.currentWord);
    };
    CasePracticeAuthorizationMainComponent.prototype.showSelfTalk = function () {
        $('#talkBox1').fadeIn(200);
        $(this.getDomIdByExpression(this.oldExpression)).fadeOut(200);
        if (!this.oldExpression) {
            $(this.getDomIdByExpression(this.currentExpression)).fadeOut(200);
        }
    };
    CasePracticeAuthorizationMainComponent.prototype.closeSelfTalk = function () {
        $('#talkBox1').fadeOut(200);
        $(this.getDomIdByExpression(this.currentExpression)).fadeIn(200);
    };
    return CasePracticeAuthorizationMainComponent;
}());
export { CasePracticeAuthorizationMainComponent };



// WEBPACK FOOTER //
// ./src/app/case-practice-authorization-main/case-practice-authorization-main.component.ts.pre-build-optimizer.js